export enum moduleUserNames {
  SET_USER = "SET_USER",
  SET_ACCOUNTS = "SET_ACCOUNTS",
  SET_DETAILS_DEVELOPMENT = "SET_DETAILS_DEVELOPMENT",
}
